import { apiClient } from '../services/api-client';

/**
 * PUTs a FHIR resource through the `/fhir` proxy.
 *
 * The response is unvalidated JSON, so `TResource` is an unchecked claim confined to
 * this boundary rather than validation — see the note in `FHIRFetcher`. It defaults to
 * `fhir4.Resource` because FHIR's `update` interaction answers with the persisted
 * resource, and the call sites update unrelated resource types (`Observation`, `Flag`,
 * `Practitioner`, `Patient`).
 *
 * `data` is `unknown`: `home/alerts/index.tsx` sends a locally widened `Flag`, and the
 * body is serialised without being read here.
 */
const FHIRUpdater = async <TResource = fhir4.Resource>(
  endPoint: string,
  token: string,
  data: unknown,
): Promise<TResource> => {
  const dataEndPoint = '/fhir' + endPoint;

  const result = await apiClient.put<TResource>('fhir-proxy', dataEndPoint, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: data,
  });
  return result;
};

export default FHIRUpdater;
